import { Grid } from '@mui/material';
import { SimpleShowLayout, TextField } from 'react-admin';
import { AccountHolderEmploymentStatusDto } from 'src/dtos';
import { AddressDetails } from 'src/lib';
import { AccountHolder } from 'src/models';

interface FinancialEmploymentDetailsProps {
  record: AccountHolder;
}

export const FinancialEmploymentDetails = ({ record }: FinancialEmploymentDetailsProps) => {
  return (
    <Grid container direction='row' spacing={2}>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='financialInformation.employmentStatus.label' label='Employment Status' />
        </SimpleShowLayout>
      </Grid>
      {record.financialInformation?.employmentStatus?.value === AccountHolderEmploymentStatusDto.Employed && (
        <Grid item md={6}>
          <SimpleShowLayout>
            <TextField record={record} source='financialInformation.jobTitle' label='Job Title' />
          </SimpleShowLayout>
        </Grid>
      )}
      {record.financialInformation?.employmentStatus?.value === AccountHolderEmploymentStatusDto.Employed && (
        <>
          <Grid item md={6}>
            <SimpleShowLayout>
              <TextField record={record} source='financialInformation.employerName' label='Employer Name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={6}>
            <SimpleShowLayout>
              <TextField record={record} source='financialInformation.yearsEmployed.label' label='Years Employed' />
            </SimpleShowLayout>
          </Grid>
        </>
      )}
      {record.financialInformation?.employerAddress && (
        <Grid item sm={12}>
          <AddressDetails record={record.financialInformation.employerAddress} />
        </Grid>
      )}
    </Grid>
  );
};
